export default __webpack_public_path__ + "static/media/PadlockOrange.7ae7f366.svg";